<template>
    <div id="app" class="app-main">
        <router-view />
    </div>
</template>
<script>
export default {
    name: 'app',
    components: {

    }
}
</script>
<style>
html,
body {
    width: 100%;
    height: 100%;
    background: #f0f0f0;
    overflow: hidden;
}
.el-button {
    position: relative;
}
.el-button .el-badge{
    position: absolute;
    top:-5px;
    right: -5px;
}
.layout {
    border: 1px solid #d7dde4;
    background: #f5f7f9;
    position: relative;
    border-radius: 4px;
    overflow: hidden;
    height: 100%;
}

.ivu-layout {
    height: 100%;
}

.ivu-table {
    height: auto;
}

.layout-logo {
    background: #17233d;
    color: #fff;
    height: 60px;



    position: relative;
    text-align: center;
    padding: 10px;
}

.layout-nav {
    margin: 0 20px 0 200px;
}

.ivu-btn {
    margin-right: 10px;
}

.demo-upload-list {
    display: inline-block;
    width: 102px;
    height: 102px;
    text-align: center;
    line-height: 102px;
    border: 1px solid transparent;
    border-radius: 4px;
    overflow: hidden;
    background: #fff;
    position: relative;
    box-shadow: 0 1px 1px rgba(0, 0, 0, .2);
    margin-right: 4px;
}

.demo-upload-list img {
    width: 100%;
    height: 100%;
}

.demo-upload-list-cover {
    display: none;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(0, 0, 0, .6);
}

.demo-upload-list:hover .demo-upload-list-cover {
    display: block;
}

.demo-upload-list-cover i {
    color: #fff;
    font-size: 20px;
    cursor: pointer;
    margin: 0 2px;
}

.app-main {
    width: 100%;
    height: 100%;
    overflow: scroll;
}

.tips {
    color: #ff9900;
    font-size: 16px;
}

.tips.success {
    color: #19be6b
}

.tips.error {
    color: #ed4014
}

.tips.info {
    color: #2db7f5
}

.ivu-alert {
    font-size: 14px;
    line-height: 20px;
}

.state-success-full {
    background: #19be6b;

    color: #fff;
    padding: 5px;
}

.state-primary-full {
    background: #2d8cf0;
    padding: 5px;
    color: #fff;
}

.state-warning-full {
    background: #ff9900;

    color: #fff;
    padding: 5px;
}

.state-error-full {
    padding: 5px;
    background: #ed4014;

    color: #fff;
}

.state-info-full {
    background: #2db7f5;
    padding: 5px;

    color: #fff;
}

.state-default {

    color: #17233d;
}

.state-success {
    color: #19be6b;

}

.state-primary {
    color: #2d8cf0;

}

.state-warning {
    color: #ff9900;

}

.state-error {
    color: #ed4014;

}

.state-info {
    color: #2db7f5;

}

.orderitem {

    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: horizontal;
    -webkit-box-direction: normal;
    -ms-flex-direction: row;
    flex-direction: row;

    padding: 5px 0px;
    border-bottom: 1px dotted #cecece;
}

.orderitem .item-product {

    font-size: 12px;
    width: 260px;
    overflow: hidden;
}

.orderitem .item-images {
    position: relative;
    width: 56px;
    height: 56px;
    -ms-flex-negative: 0;
    flex-shrink: 0;
    border-radius: 2px;
    margin-right: 16px;
    overflow: hidden;
    background-repeat: no-repeat;
    background-position: 50%;
    background-size: cover;
    background-color: rgba(0, 0, 0, .03);
}

.orderitem .item-images img {
    height: 100%;
    width: 100%;
}

.orderitem:last-child {
    border-bottom: none;
}

.order-name {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    word-break: break-all;
}

.order-attr {
    color: #8c8c8c;
    /*white-space: nowrap;*/
  /*  overflow: hidden;
    text-overflow: ellipsis;*/
}

.tipsClass {
    text-align: center;
    padding: 5px;
    color: #f00;
    font-size: 14px;
}

.express-item {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: horizontal;
    -webkit-box-direction: normal;
    -ms-flex-direction: row;
    flex-direction: row;

    position: relative;
    padding: 5px 0px;
    border-bottom: 1px dotted #cecece;
}

.express-item:last-child {
    border-bottom: none;
}

.express-item-images {
    position: relative;


    width: 150px;
    min-height: 150px;
    -ms-flex-negative: 0;
    flex-shrink: 0;
    border-radius: 2px;
    margin-right: 16px;

}

.express-item-images:after {
    clear: both;
    content: " ";
    display: block;
    width: 1px;
}

.express-item-images img {
    width: 100%;
    height: 100%;
    float: left;
    margin-left: 10px;
}

.express-item-product {
    overflow-x: scroll;
    font-size: 12px;
    width: 100%;
    overflow: hidden;
}

.express-item-name {


    display: -webkit-box;

    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    word-break: break-all;
}

.express-item-attr {
    color: #8c8c8c;
    white-space: nowrap;
    overflow: hidden;
    font-size: 14px;
    line-height: 2;
    text-overflow: ellipsis;
}

.hidemore {
    display: none;
}

.showmore {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: horizontal;
    -webkit-box-direction: normal;
    -ms-flex-direction: row;
    flex-direction: row;
}


.sm-express-item {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: horizontal;
    -webkit-box-direction: normal;
    -ms-flex-direction: row;
    flex-direction: row;


    padding: 5px 0px;
    border-bottom: 1px dotted #cecece;
}

.sm-express-item:last-child {
    border-bottom: none;
}

.sm-express-item-images {
    position: relative;


    width: 80px;
    min-height: 80px;
    -ms-flex-negative: 0;
    flex-shrink: 0;


    border: 1px solid transparent;
    border-radius: 4px;
    overflow: hidden;
    background: #fff;
    position: relative;
    -webkit-box-shadow: 0 1px 1px rgba(0, 0, 0, .2);
    box-shadow: 0 1px 1px rgba(0, 0, 0, .2);
    margin-right: 4px;

}

.ivu-carousel-item img.ep {

    width: 100%;
    overflow: hidden;
}

.sm-express-item-image-cover {

    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(0, 0, 0, .6);
    color: #fff;
    font-weight: bold;
}

.sm-express-item-images:after {
    clear: both;
    content: " ";
    display: block;
    width: 1px;
}

.sm-express-item-images img {
    width: 100%;
    height: 100%;
    overflow: hidden;

}

.sm-express-item-product {
    overflow-x: scroll;
    font-size: 12px;
    width: 100%;
    overflow: hidden;
}

.sm-express-item-name {


    display: -webkit-box;

    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    word-break: break-all;
}

.sm-express-item-attr {
    color: #8c8c8c;
    white-space: nowrap;
    overflow: hidden;
    font-size: 14px;
    line-height: 2;
    text-overflow: ellipsis;
}

.sm-express-item-op {
    margin: 10px 0px;
}

.sidebar-menu-con::-webkit-scrollbar {
    width: 0;
}

.sidebar-menu-con::-webkit-scrollbar-thumb {
    background: #e8eaec;
}

.sidebar-menu-con::-webkit-scrollbar-track {
    background-color: transparent;
}



.main .single-page-con::-webkit-scrollbar {
    width: 0;
}

.main .single-page-con::-webkit-scrollbar-thumb {
    background: #e8eaec;
}

.tdrelative {
    position: relative;
}

.main .single-page-con::-webkit-scrollbar-track {
    background-color: transparent;
}


.sub-title{
    position: absolute;
    top:0;
    right: 0;
    left: 0;
}
.sub-title>div{
    display: inline-block;
    color: #fff;
    width: 100%;
    height: 20px;
    text-align: center;
    line-height: 20px;
    position: relative;

}
.sub-title>div:after {
    display: none;
    content: "";
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 20px 18px 0 0;
    line-height: 20px;
    zoom: 1;
    position: absolute;
    top: 0;
    right: -18px;
}

.sub-title>div:before {
    display: none;
    content: "";
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 20px 18px 0 0;
    line-height: 20px;
    zoom: 1;
    position: absolute;
    top: 0;
    left: -18px;
    border-color:#ee4d2d;

}.sub-title .packageName{
    background-color: #ee4d2d;
}
.sub-title .packageName:after {
    border-color: #ee4d2d transparent transparent;
}
.sub-title .packageName.cross{
    background-color: #67c23a;
}
.sub-title .packageName.cross:after {
    border-color: #67c23a transparent transparent;
}
.sub-title>div.cross:before{
    border-color:#67c23a;
}

.tabname {
    height: 100%;
    position: relative;
    padding: 25px 0px 10px;
    line-height: 1.5;
}

.state-default-border {
    padding: 0px 5px;
    color: #17233d;
    border: 1px solid #17233d;
}

.state-success-border {
    color: #19be6b;
    padding: 0px 5px;
    border: 1px solid #19be6b;

}

.state-primary-border {
    color: #2d8cf0;
    padding: 0px 5px;
    border: 1px solid #2d8cf0;

}

.state-warning-border {
    color: #ff9900;
    padding: 0px 5px;
    border: 1px solid #ff9900;

}

.state-error-border {
    color: #ed4014;
    padding: 0px 5px;
    border: 1px solid #ed4014;

}

.state-info-border {
    color: #2db7f5;
    padding: 0px 5px;
    border: 1px solid #2db7f5;

}
</style>